import { FiChevronRight } from '../react-icons/main';
import IconV2 from '../v2/IconV2';

const ChevronTitle = ({ left, right }) => {
  return (
    <span className="command-bar-chevron-title">
      <div className="command-bar-chevron-title-dark">{left}</div>
      <IconV2 icon={FiChevronRight} />
      <div className={'label'}>{right}</div>
    </span>
  );
};

export default ChevronTitle;
